/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CustomerLastActivityInternalRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'
import {CustomerLastActivityInternalResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'


export const customerLastActivityInternal = (request: CustomerLastActivityInternalRequest, options?: CashRequestOptions) => post<CustomerLastActivityInternalRequest, CustomerLastActivityInternalResponse>("/2.0/cash/customer-last-activity-internal", request, {...options, rejectOnError: true })